export default __webpack_public_path__ + "static/media/info_mine.min.8cec8162.png";